import { render, staticRenderFns } from "./completed-demo-request-all-list.html?vue&type=template&id=2b5a5dbc&scoped=true&external"
import script from "./completed-demo-request-all-list.js?vue&type=script&lang=js&external"
export * from "./completed-demo-request-all-list.js?vue&type=script&lang=js&external"
import style0 from "./completed-demo-request-all-list.scss?vue&type=style&index=0&id=2b5a5dbc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5a5dbc",
  null
  
)

export default component.exports